import { render, staticRenderFns } from "./GraphCard.vue?vue&type=template&id=1d97454c&scoped=true"
import script from "./GraphCard.vue?vue&type=script&lang=js"
export * from "./GraphCard.vue?vue&type=script&lang=js"
import style0 from "./GraphCard.vue?vue&type=style&index=0&id=1d97454c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d97454c",
  null
  
)

export default component.exports